export const cacheProvider = {
  get: (language, key) =>
    // @ts-ignore
    ((JSON.parse(localStorage.getItem('translations')) || {})[key] || {})[language],
  set: (language, key, value) => {
    // @ts-ignore
    const existing = JSON.parse(localStorage.getItem('translations')) || {
      [key]: {},
    };
    existing[key] = { ...existing[key], [language]: value };
    localStorage.setItem('translations', JSON.stringify(existing));
  },
};
